<template>
  <v-layout>
    <v-flex md mt-5>
      <v-card
        class="mx-auto elevation-4"
        max-width="500"
        :dark="config.dark_background"
        :color="config.background_dark"
      >
        <v-toolbar
          v-bind:color="config.primary"
          dark
          flat
        >
          <v-toolbar-title>
            <v-icon>mdi-account-plus</v-icon> Create An Account
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
          icon
          large
          @click="navigateTo({name: 'home'})"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-toolbar>
        <v-spacer />
        <div v-if="errors.length > 0" class="container">
          <v-alert
          v-bind:color="config.alert"
          class="m-2"
          dark
          >
            <ul>
              <li
                v-bind:key="index"
                v-for="(error, index) in errors"
                class="mb-2 mt-2"
              >
              <strong>{{ error }}</strong>
              </li>
            </ul>
          </v-alert>
        </div>
        <v-card-text class="">
          <v-form
            @submit.prevent="register"
            autocomplete="off"
            name="register-form"
            >
            <v-text-field
              :rules="rules"
              id="name"
              prepend-icon="mdi-account"
              label="Username"
              type="name"
              v-model="user.name"
              :error="userError.name"
            ></v-text-field>
            <v-text-field
              :rules="rules"
              id="email"
              prepend-icon="mdi-email"
              label="Email"
              v-model="user.email"
              class="mb-3"
              :error="userError.email"
            ></v-text-field>
            <v-text-field
              :rules="rules"
              id="password"
              prepend-icon="mdi-lock"
              label="Password"
              type="password"
              v-model="user.password"
              class="mb-3"
              autocomplete="new-password"
              :error="userError.password"
            ></v-text-field>
            <v-text-field
              :rules="rules"
              id="password2"
              prepend-icon="mdi-lock-alert"
              label="Confirm Password"
              type="password"
              v-model="user.password2"
              class="mb-3"
              :error="userError.password2"
            ></v-text-field>
            <v-dialog
              v-model="dialog"
              width="70%"
            >
              <modal>
                <template v-slot:title>
                  <div></div>
                </template>
                <template v-slot:text>
                  <legal-modal>
                  </legal-modal>
                </template>
                <template v-slot:actions>
                  <div style="width: 80%; margin-right: auto; margin-left: auto;">
                    <v-row justify="center">
                      <v-col cols="12" sm="6">
                        <v-btn
                          v-bind:color="config.confirm"
                          block
                          @click="user.eula = true; dialog = false"
                        >
                          Accept
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-btn
                          v-bind:color="config.cancel"
                          block
                          @click="user.eula = false; dialog = false"
                        >
                          Decline
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </template>
              </modal>
            </v-dialog>
            <v-flex class="d-flex">
              <div class="terms-btn">
                <v-btn
                  id="t"
                  left
                  v-bind:color="config.secondary"
                  dark
                  @click="dialog = true"
                >
                  Terms and conditions
                </v-btn>
              </div>
              <v-btn
                :loading="loading"
                dark
                right
                class="ml-auto"
                v-bind:color="config.primary"
                type="submit">
                Register
              </v-btn>
            </v-flex>
              <div class="pa-2 ml-auto mt-4">
                Already have an account? Login <a @click="navigateTo('login')"> here </a>
              </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthService from '@/services/AuthService'
import Modal from '@/components/Modal'
import LegalModal from '@/components/LegalModal'
import config from '@/config/config'
export default {
  name: 'register',
  data () {
    return {
      termsColor: config.secondary,
      rules: [
        value => !!value || 'Required.',
        value => (value || '').length <= 30 || 'Max 30 characters'
      ],
      user: {
        name: '',
        email: '',
        password: '',
        password2: '',
        eula: false
      },
      userError: {
        name: false,
        email: false,
        password: false,
        password2: false,
        eula: false
      },
      errors: [],
      dialog: false,
      config,
      loading: false
    }
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    },
    async register () {
      this.loading = true
      let userErrors = []
      if (this.user.eula == false) {
        document.getElementById("t").classList.remove('terms-btn')
        document.getElementById("t").classList.add('terms-btn-active')
        setTimeout(() => {
          document.getElementById("t").classList.remove('terms-btn-active')
          document.getElementById("t").classList.add('terms-btn')
        }, 500);
      }
      await Object.keys(this.user).forEach(key => {
        if (this.user[key] == '' && key != 'eula') {
          this.userError[key] = true
          userErrors.push(key)
        } else {
          this.userError[key] = false
        }
      })
      if (userErrors.length == 0) {
        return AuthService.register(this.user).then(response => {
          if (response.status == 200) {
            this.$store.dispatch('login', response.data)
            this.$router.push('browse')
            this.loading = false
          }
        }).catch((error) => {
          this.errors = error.response.data.errors
          this.loading = false
        });
      } else {
        this.loading = false
      }
    }
  },
  components: {
    Modal,
    LegalModal
  }
}
</script>

<style scoped>

  .terms-btn-active {
     animation: alert 0.5s ease-in-out;
  }

  @keyframes alert {
    0% {
      background: none;
      outline: none;
    }
    50% {
      background: rgba(255, 0, 0, 0.753);
    }
    100% {
      background: none;
      outline: none;
    }
  }


</style>